module.exports = __webpack_public_path__ + "img/A1 (3).86fb896b.jpg";